export const talonOneApi = {
  host: 'talonOneEndpoint/getTrackEvent',
  host2 : 'talonOneEndpoint/getTrackEventItemPurchased',
  anonymousItems: 'itemTalonDiscounts',
  credits: 'talon-one/credits/:customerId',
  transactions: 'talon-one/credits/:customerId/transactions',
  info: 'talon-one/credits/info',
};
